import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = { class: "max-w-6xl mx-auto px-4 py-6" }
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-5 gap-6" }
const _hoisted_4 = { class: "lg:col-span-3" }
const _hoisted_5 = { class: "flex items-center justify-between mb-4" }
const _hoisted_6 = { class: "text-lg font-bold text-gray-900" }
const _hoisted_7 = {
  href: '/news',
  class: "text-sm text-blue-700 hover:underline"
}
const _hoisted_8 = {
  key: 0,
  class: "text-sm text-gray-400 py-8 text-center"
}
const _hoisted_9 = { class: "space-y-4" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "p-4" }
const _hoisted_13 = { class: "text-base font-semibold text-gray-900 hover:text-blue-700 mb-1" }
const _hoisted_14 = { class: "text-xs text-gray-500 mb-2" }
const _hoisted_15 = { class: "text-sm text-gray-600" }
const _hoisted_16 = { class: "flex items-center gap-3 mt-2" }
const _hoisted_17 = { class: "text-xs text-gray-400" }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "lg:col-span-2 flex flex-col gap-6" }
const _hoisted_21 = { class: "flex items-center justify-between mb-4" }
const _hoisted_22 = { class: "text-lg font-bold text-gray-900" }
const _hoisted_23 = {
  href: '/forum',
  class: "text-sm text-blue-700 hover:underline"
}
const _hoisted_24 = {
  key: 0,
  class: "text-sm text-gray-400 py-4 text-center bg-white rounded-xl border border-gray-200"
}
const _hoisted_25 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 divide-y divide-gray-100" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "text-sm font-medium text-gray-900 hover:text-blue-700" }
const _hoisted_28 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_29 = { class: "flex items-center justify-between mb-4" }
const _hoisted_30 = { class: "text-lg font-bold text-gray-900" }
const _hoisted_31 = {
  href: '/shared_runs',
  class: "text-sm text-blue-700 hover:underline"
}
const _hoisted_32 = {
  key: 0,
  class: "text-sm text-gray-400 py-4 text-center bg-white rounded-xl border border-gray-200"
}
const _hoisted_33 = { class: "space-y-3" }
const _hoisted_34 = ["href"]
const _hoisted_35 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_36 = { class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" }
const _hoisted_37 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_38 = {
  key: 1,
  class: "text-xs text-gray-500"
}
const _hoisted_39 = { class: "text-sm text-gray-700" }
const _hoisted_40 = { class: "text-xs text-gray-400" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "flex items-center justify-between mb-4" }
const _hoisted_43 = { class: "text-lg font-bold text-gray-900" }
const _hoisted_44 = {
  href: "/competitions",
  class: "text-sm text-blue-700 hover:underline"
}
const _hoisted_45 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_46 = ["href"]
const _hoisted_47 = ["src"]
const _hoisted_48 = {
  key: 1,
  class: "h-20 mx-auto flex items-center justify-center bg-gray-50 rounded-lg border border-gray-200 mb-2"
}
const _hoisted_49 = { class: "text-xs font-medium text-blue-700 mb-0.5" }
const _hoisted_50 = { class: "text-sm font-semibold text-gray-900 leading-tight" }
const _hoisted_51 = { class: "py-6 text-center text-gray-500 text-sm" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "home"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createCommentVNode(" Main content: 2 columns "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createCommentVNode(" Left column: News (3/5) "),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString($setup.t('home.latest_news')), 1 /* TEXT */),
            _createElementVNode("a", _hoisted_7, _toDisplayString($setup.t('home.all_news')) + " →", 1 /* TEXT */)
          ]),
          ($setup.newsItems.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($setup.t('home.no_news')), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsItems, (item) => {
              return (_openBlock(), _createElementBlock("a", {
                key: item.id,
                href: `/news/${item.id}`,
                class: "block bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition overflow-hidden"
              }, [
                (item.cover_image_url)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: $setup.coverUrl(item),
                      class: "w-full"
                    }, null, 8 /* PROPS */, _hoisted_11))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h3", _hoisted_13, _toDisplayString(item.title), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(item.user.name) + " · " + _toDisplayString($setup.formatDate(item.created_at)), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_15, _toDisplayString($setup.stripHtml(item.body).substring(0, 150)) + _toDisplayString($setup.stripHtml(item.body).length > 150 ? '...' : ''), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(item.comments_count) + " " + _toDisplayString($setup.t('home.comments')), 1 /* TEXT */),
                    ($props.userAdmin)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("a", {
                            href: `/news/${item.id}/edit`,
                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                            class: "text-xs text-blue-700 hover:underline"
                          }, _toDisplayString($setup.t('news.edit')), 9 /* TEXT, PROPS */, _hoisted_18),
                          _createElementVNode("button", {
                            onClick: _withModifiers($event => ($setup.deleteNewsItem(item)), ["stop","prevent"]),
                            class: "text-xs text-red-500 hover:underline"
                          }, _toDisplayString($setup.t('news.delete')), 9 /* TEXT, PROPS */, _hoisted_19)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ])
              ], 8 /* PROPS */, _hoisted_10))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        _createCommentVNode(" Right column (2/5): split vertically "),
        _createElementVNode("div", _hoisted_20, [
          _createCommentVNode(" Top forum topics "),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("h2", _hoisted_22, _toDisplayString($setup.t('home.hot_topics')), 1 /* TEXT */),
              _createElementVNode("a", _hoisted_23, _toDisplayString($setup.t('home.all_forum')) + " →", 1 /* TEXT */)
            ]),
            ($props.topTopics.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString($setup.t('home.no_topics')), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.topTopics, (topic) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: topic.id,
                  href: `/forum/${topic.id}`,
                  class: "block px-4 py-3 hover:bg-gray-50 transition"
                }, [
                  _createElementVNode("h4", _hoisted_27, _toDisplayString(topic.title), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_28, _toDisplayString(topic.user.name) + " · " + _toDisplayString(topic.messages_count) + " " + _toDisplayString($setup.t('home.new_messages')) + " · " + _toDisplayString(topic.total_messages) + " " + _toDisplayString($setup.t('home.total')), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_26))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "border-gray-200" }, null, -1 /* CACHED */)),
          _createCommentVNode(" Today's shared runs "),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("h2", _hoisted_30, _toDisplayString($setup.t('home.today_runs')), 1 /* TEXT */),
              _createElementVNode("a", _hoisted_31, _toDisplayString($setup.t('home.all_runs')) + " →", 1 /* TEXT */)
            ]),
            ($props.todayRuns.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString($setup.t('home.no_runs_today')), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.todayRuns, (run) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: run.id,
                  href: `/shared_runs/${run.id}`,
                  class: "block bg-white rounded-xl shadow-sm border border-gray-200 p-4 hover:shadow-md transition"
                }, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("span", _hoisted_36, _toDisplayString($setup.formatTime(run.date)), 1 /* TEXT */),
                    (run.distance)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(run.distance) + " " + _toDisplayString($setup.t('home.km')), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (run.pace)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(run.pace) + " " + _toDisplayString($setup.t('home.min_km')), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("p", _hoisted_39, _toDisplayString(run.organizer.name), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_40, _toDisplayString(run.participants_count) + " " + _toDisplayString($setup.t('home.participants')), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_34))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "border-gray-200" }, null, -1 /* CACHED */)),
          _createCommentVNode(" Upcoming competitions "),
          ($props.upcomingCompetitions.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("h2", _hoisted_43, _toDisplayString($setup.t('home.upcoming_competitions')), 1 /* TEXT */),
                  _createElementVNode("a", _hoisted_44, _toDisplayString($setup.t('home.all_competitions')) + " →", 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_45, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.upcomingCompetitions, (comp) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: comp.id,
                      href: `/competitions/${comp.id}`,
                      class: "block bg-white rounded-xl shadow-sm border border-gray-200 p-4 hover:shadow-md transition text-center"
                    }, [
                      (comp.logo_url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: comp.logo_url,
                            class: "h-20 mx-auto rounded-lg object-contain border border-gray-200 mb-2"
                          }, null, 8 /* PROPS */, _hoisted_47))
                        : (_openBlock(), _createElementBlock("div", _hoisted_48, [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("svg", {
                              class: "w-8 h-8 text-gray-300",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                              })
                            ], -1 /* CACHED */)
                          ]))])),
                      _createElementVNode("p", _hoisted_49, _toDisplayString($setup.formatCompDate(comp.date)), 1 /* TEXT */),
                      _createElementVNode("p", _hoisted_50, _toDisplayString(comp.name), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_46))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createCommentVNode(" Footer "),
    _createElementVNode("footer", _hoisted_51, [
      _createElementVNode("p", null, "© 2026 Alerg.Eu. " + _toDisplayString($setup.t('footer.rights')), 1 /* TEXT */)
    ])
  ]))
}